const isString = key => typeof key === 'string';

const mapPropsToLowerCase = source => Object.keys(source)
  .filter(isString)
  .reduce((lower, key) => {
    lower[key.toLowerCase()] = source[key];
    return lower;
  }, {});

const mapPropsFromSource = (keys, source) => {
  const sourceLower = mapPropsToLowerCase(source);

  return keys
    // .filter(isValue)
    .reduce((result, key) => {
      result[key] = isString(key)
        ? sourceLower[key.toLowerCase()]
        : source[key];

      return result;
    }, {});
};

const caseInsensitivePropertyMapper = {
  map(keys = []) {
    return {
      from(source = {}) {
        return mapPropsFromSource(keys, source);
      }
    };
  }
};

export default caseInsensitivePropertyMapper;
